import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule, GrowlModule, TooltipModule } from 'primeng/primeng';
import { HelperModule } from '../../../../common/helper/helper.module';
import { CardModule } from '../../../../layout/card';
import { PaginationModule } from '../../../../layout/pagination';
import { ToastrModule } from 'ngx-toastr';
import { Select2Module } from 'ng2-select2';
import { CampaignComponent } from './campaign.component';
import { DetailComponent } from './detail/detail.component';
import { ListComponent } from './list/list.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ComponentsModule } from '../../../../components/component.module';
import { ContactsComponent } from './detail/contacts/contacts.component';
import { AgentsComponent } from './detail/agents/agents.component';
import { ReportComponent } from './report/report.component';
import { ChartModule } from 'angular2-highcharts';
import { AppTagsInputModule } from '../../../../common/tags-input/tags-input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule,
    GrowlModule,
    TooltipModule,
    BrowserModule,
    HelperModule,
    CardModule,
    PaginationModule,
    ToastrModule.forRoot(),
    Select2Module,
    ChartModule,
    BsDatepickerModule.forRoot(),
    ComponentsModule,
    CommonModule,
    AppTagsInputModule,
  ],

  declarations: [
    CampaignComponent,
    DetailComponent,
    ListComponent,
    ContactsComponent,
    AgentsComponent,
    ReportComponent,
  ],
  exports: [CampaignComponent],
  entryComponents: [],
  providers: [],
})
export class CampaignModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/campaign/campaign.module.ts